var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-5"},[_c('h3',[_vm._v("\n        "+_vm._s(_vm.$t("not_found.message"))+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }